import { render, staticRenderFns } from "./IntegrationItem.vue?vue&type=template&id=f8f0b4b4&"
import script from "./IntegrationItem.vue?vue&type=script&lang=js&"
export * from "./IntegrationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports